import { render, staticRenderFns } from "./AppointmentDocumentsInfoModal.vue?vue&type=template&id=737db0e0&"
import script from "./AppointmentDocumentsInfoModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppointmentDocumentsInfoModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('737db0e0')) {
      api.createRecord('737db0e0', component.options)
    } else {
      api.reload('737db0e0', component.options)
    }
    module.hot.accept("./AppointmentDocumentsInfoModal.vue?vue&type=template&id=737db0e0&", function () {
      api.rerender('737db0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/AppointmentDocumentsInfoModal.vue"
export default component.exports